export default __webpack_public_path__ + "static/media/hero-caro-new-october.22f61a33.png";